var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVrGlasses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 14C4 12.8954 4.89543 12 6 12H18C19.1046 12 20 12.8954 20 14C20 18.4183 16.4183 22 12 22C7.58172 22 4 18.4183 4 14Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.59985 3C7.04757 3 6.59985 3.44772 6.59985 4V4.20007C6.26855 4.20015 6 4.46875 6 4.80007V7.20007C6 7.5314 6.26855 7.79999 6.59985 7.80007V8C6.59985 8.55228 7.04757 9 7.59985 9H9.89899C10.4618 9 10.9874 8.71872 11.2996 8.25043C11.6327 7.75072 12.367 7.75072 12.7001 8.25043C13.0123 8.71872 13.5379 9 14.1007 9H16.3999C16.9521 9 17.3999 8.55228 17.3999 8V7.80007C17.7312 7.80007 17.9999 7.53144 17.9999 7.20007V4.80007C17.9999 4.4687 17.7313 4.20007 17.3999 4.20007V4C17.3999 3.44772 16.9521 3 16.3999 3H7.59985ZM9 7C8.44771 7 8 6.55228 8 6C8 5.44772 8.44771 5 9 5C9.55229 5 10 5.44772 10 6C10 6.55228 9.55229 7 9 7ZM16 6C16 6.55228 15.5523 7 15 7C14.4477 7 14 6.55228 14 6C14 5.44772 14.4477 5 15 5C15.5523 5 16 5.44772 16 6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVrGlasses);
export default __webpack_public_path__ + "static/media/vr-glasses.c56e52b62b6a5a74121dbc61330aba5c.svg";
export { ForwardRef as ReactComponent };